export default "__VITE_ASSET__AhL6xTKv__"